import { render } from "./Textarea.vue?vue&type=template&id=5f6fb64b&scoped=true&ts=true"
import script from "./Textarea.vue?vue&type=script&lang=ts"
export * from "./Textarea.vue?vue&type=script&lang=ts"

import "./Textarea.vue?vue&type=style&index=0&id=5f6fb64b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6fb64b"]])

export default __exports__